import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import SolicitacaoService from "../../services/resource/solicitacaoService";

const service = new SolicitacaoService();

// Lista "Todas as Solicitações". tipoProcesso/status/dataInicial/dataFinal são filtrados no
// backend — os demais filtros (solicitante, responsável, grupo) são aplicados no componente sobre
// este resultado. Chamadores que não passam dataInicial/dataFinal (Dashboard, Central de Tarefas)
// continuam recebendo a lista completa, sem filtro de período.
export function useSolicitacoes(tipoProcesso, status, dataInicial, dataFinal) {
    const [solicitacoes, setSolicitacoes] = useState([]);
    const [loading, setLoading] = useState(true);

    const carregar = useCallback(() => {
        setLoading(true);
        service.listarSolicitacoes(tipoProcesso || undefined, status || undefined, dataInicial || undefined, dataFinal || undefined)
            .then(res => setSolicitacoes(res.data))
            .catch(error => {
                console.error("Erro ao listar solicitações", error);
            })
            .finally(() => setLoading(false));
    }, [tipoProcesso, status, dataInicial, dataFinal]);

    useEffect(() => {
        carregar();
    }, [carregar]);

    return { solicitacoes, loading, recarregar: carregar };
}
